// src/constants/dataTypes.js

export const repUnits = {
  Dynamic: 'Dynamic' ,
  Fixed: 'Fixed (ACT26 compatible)'
}



// export const fwdDataTypes = [
//   { value: 'DMReadout', label: 'Meter readout' },
//   { value: 'DMScan', label: 'Meter scan' },
//   { value: 'QnodeReadout', label: 'Network readout' },
//   { value: 'QnodeScan', label: 'Network scan' },
//   { value: 'CustomerReport', label: 'Report' }
// ];
